import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import { LanguageContext } from "App";
import MDBox from "components/MDBox";
import Icon from "@mui/material/Icon";
import MDTypography from "components/MDTypography";
import Loader from "Loader";
import { useNavigate } from "react-router-dom";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import Pagination from "@mui/material/Pagination";
import CreatePackageReq from "Classes/Models/Requests/AccountingSessions/CreatePackageReq";
import SessionsApi from "Classes/API/Administration/SessionsApi";
import { useContext } from "react";
const PatientPackagesTable = ({ patient }) => {
  let navigate = useNavigate();
  const { translations, switchLanguage } = useContext(LanguageContext);

  const TableColumns = [
    {
      Header: translations.userManagementInfoUserAccountingPackgesforId,
      accessor: "Id",
      align: "left",
    },
    {
      Header: translations.userManagementInfoUserAccountingPackgesforPackage,
      accessor: "Name",
      align: "left",
    },
    {
      Header: translations.userManagementInfoUserAccountingPackgesforPatient,
      accessor: "Patient",
      align: "left",
    },
    {
      Header: translations.userManagementInfoUserAccountingPackgesforPaidFor,
      accessor: "PaidFor",
      align: "left",
    },
    {
      Header: translations.userManagementInfoUserAccountingPackgesforOriginalPrice,
      accessor: "OriginalPrice",
      align: "left",
    },
    {
      Header: translations.userManagementInfoUserAccountingPackgesforDiscount,
      accessor: "Discount",
      align: "left",
    },
    {
      Header: translations.userManagementInfoUserAccountingPackgesforFinalPrice,
      accessor: "FinalPrice",
      align: "left",
    },
    {
      Header: translations.userManagementInfoUserAccountingPackgesforDetails,
      accessor: "Details",
      align: "center",
    },
  ];
  const [TableDataRows, setTableDataRows] = useState([]);
  const [ResponseData, setResponseData] = useState({});
  const [Response, setResponse] = useState({});
  const [IsLoaded, setIsLoaded] = useState(false);
  const [PaginationPages, setPaginationPages] = useState(0);
  const [Page, setPage] = useState(1);
  const [Reload, setReload] = useState(false);

  const MakeTableRow = (pkg, index) => {
    return {
      Id: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {pkg.id}
        </MDTypography>
      ),
      Name: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {pkg.packageName}
        </MDTypography>
      ),
      Patient: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {pkg.getPatient.getUser.name}
        </MDTypography>
      ),
      PaidFor: (
        <input
          id={"pkg.isPaidFor" + pkg.id}
          type="checkbox"
          disabled
          defaultChecked={pkg.isPaidFor}
        />
      ),
      OriginalPrice: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {pkg.originalPrice}
        </MDTypography>
      ),
      Discount: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Number(pkg.discount).toFixed(1)}%
        </MDTypography>
      ),
      FinalPrice: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {pkg.finalPrice}
        </MDTypography>
      ),
      Details: (
        <MDButton
          onClick={() => navigate("/Users/Options/PackageDetails", { state: { pkg: pkg } })}
        >
          <Icon sx={{ fontWeight: "bold" }}>more_vert</Icon>
        </MDButton>
      ),
    };
  };
  const GetTableData = async () => {
    const SearchReq = new CreatePackageReq();
    SearchReq.pagingParams.pageSize = 5;
    SearchReq.pagingParams.pageNumber = Page;
    SearchReq.patientId = patient.getPatient?.id;
    var res = await SessionsApi.SearchPackages(SearchReq);
    if (res.status == "Success") {
      let tempResponseData = [...res.data.list];

      setResponseData(tempResponseData);
      setPaginationPages(res.data.totalPages);
      setIsLoaded(true);
      setReload(false);
    }
  };
  const RefreshTable = (resList) => {
    var rows = [];
    resList.forEach((session, index) => {
      rows.push(MakeTableRow(session, index));
    });
    setTableDataRows(rows);
  };
  useEffect(() => {
    setReload(true);
  }, []);
  useEffect(async () => {
    //Get data
    if (!IsLoaded) {
      await GetTableData();
    }
    if (Reload) {
      await GetTableData();
    }
  }, [IsLoaded, Reload]);
  useEffect(() => {
    //Get data
    if (ResponseData.length > 0) {
      RefreshTable(ResponseData);
    }
  }, [ResponseData]);
  if (!IsLoaded) {
    const loaderType = "balls";
    const loaderColor = "black";
    return <Loader type={loaderType} color={loaderColor} />;
  }
  return (
    <Card sx={{ marginTop: "65px", marginBottom: "65px" }}>
      <MDBox
        mx={2}
        mt={-3}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
      >
        <div class="text-center">
          <MDTypography variant="h6" color="white">
            {translations.userManagementInfoUserAccountingPackgesfor} {patient.name}
          </MDTypography>
        </div>
      </MDBox>
      <MDBox p={3}>
        <DataTable
          table={{ columns: TableColumns, rows: TableDataRows }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
        <div className="text-right mx-3 my-4">
          <Pagination
            count={PaginationPages}
            color="primary"
            onChange={(e, number) => setPage(number)}
            className="float-right"
          />
        </div>
      </MDBox>
    </Card>
  );
};

export default PatientPackagesTable;
